import * as React from "react";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading } from "uitk-react-text";
import { ContainerProps } from "../Container";

export const HotwireContainer: React.FC<Omit<ContainerProps, "view">> = ({
  children,
  fmId,
  fmTitleId,
  id,
  title,
  subHeadline,
}) => (
  <div className="HotwireCheckPrices" id={id} data-fm={fmId} data-fm-title-id={fmTitleId}>
    <UitkSpacing padding={{ block: "three" }}>
      <>
        <UitkSpacing padding={{ block: "four" }}>
          <UitkHeading level={2} size={600}>
            {title}
          </UitkHeading>
          {subHeadline && (
            <UitkSpacing margin={{ blockstart: "one" }}>
              <span className="uitk-type-300 uitk-type-regular">{subHeadline}</span>
            </UitkSpacing>
          )}
        </UitkSpacing>
        {children}
      </>
    </UitkSpacing>
  </div>
);
